import { compare, Operation } from 'fast-json-patch';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { ChangeState } from './change-state/change-state';
import { ChangeStatusEnum } from './change-state/change-status.enum';
import { LoadState } from './load-state/load-state';
import { MmModel } from './mm.model';

export class MmChangeableModel<T> extends MmModel<T> {

  private _changeState = new BehaviorSubject<ChangeState<T>>(new ChangeState({status: ChangeStatusEnum.NotChanged}));
  public changeState$ = this._changeState.asObservable();



  private changeableModelStateChange$ = combineLatest(
    this.loadState$,
    this.changeState$,
  );

  constructor(init?: Partial<MmChangeableModel<T>>) {
    super(init);
    if (init && init.changeState) {
      this.changeState = new ChangeState(init.changeState);
    } else {
      this.changeState = new ChangeState({status: ChangeStatusEnum.NotChanged});
    }

  }


  protected intiSubscription() {
    if (this.changeableModelStateChange$) {
      this.changeableModelStateChange$.subscribe(([l, c]) => { this.generateChangeableModelData(l, c); });
    }
  }

  private generateChangeableModelData(loadState: LoadState<T>, changeState: ChangeState<T>) {
    const data: T = {} as T;
    if (loadState?.data) {
      Object.assign(data, loadState?.data);
    }
    if (changeState.data) {
      Object.assign(data, changeState?.data);
    }
    this.uid = this.uid ?? (data as any).UniqueId;
    this.setData(data);
  }

  get changeState(): ChangeState<T> {
    if (this._changeState) {
      return this._changeState.value;
    }
    return null;
  }

  set changeState(v: ChangeState<T>) {
    this._changeState.next(v);
  }

  addChanges(changes: T): ChangeState<T> {
    if (changes && Object.keys(changes).length > 0) {
      const changeState = new ChangeState(this.changeState);
      if (changeState.status !== ChangeStatusEnum.New) {
        changeState.status = ChangeStatusEnum.Changed;
        changeState.date = new Date(Date.now());
      }
      Object.assign(changeState.data, changes);
      this.changeState = changeState;
    }
    return this.changeState;
  }

}
